import type { Address } from '../api/types'

export const blankAddress = (): Address => ({
  name: '',
  contact_name: '',
  email: '',
  phone: '',
  line1: '',
  line2: '',
  city: '',
  state: '',
  postal_code: '',
  country: 'US',
})

export function addressSummary(value: Address) {
  const locality = [value.city, value.state].filter(Boolean).join(', ')
  return [value.line1, locality].filter(Boolean).join(' · ') || 'Add address'
}
